import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Smartphone } from 'lucide-react'

import { useAuthStore } from '@/shared/auth/stores/authStore'
import { roleLabel } from '@/shared/constants/roles'

// Catch-all redirect target for Field Officers who
// somehow land on the web app. They're mobile-only by product design;
// this page is a polite "use the app" page with a logout escape hatch.
export const Route = createFileRoute('/mobile-only')({
  component: MobileOnlyPage,
})

function MobileOnlyPage() {
  const role = useAuthStore((s) => s.user?.role_name) as string | undefined
  const name = useAuthStore((s) => s.user?.name)
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()

  async function handleLogout() {
    await logout()
    navigate({ to: '/login' })
  }

  const roleName = role ? roleLabel(role) : 'this role'

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
      <div className="max-w-md rounded-2xl border border-gray-100 bg-white p-8 text-center shadow-xs">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-[#1a3db5]">
          <Smartphone size={26} />
        </div>
        <h1 className="text-base font-bold text-gray-900">Use the mobile app</h1>
        <p className="mt-2 text-sm text-gray-600">
          {name ? <>Hi <strong>{name}</strong>. </> : null}
          The web app is reserved for admins and Heads of Department.
          As {roleName}, your work happens on the mobile app — survey
          submissions, issue raises, and resolutions all flow through
          there.
        </p>
        <p className="mt-3 text-[11px] text-gray-400">
          If you believe this is a mistake, contact your admin.
        </p>
        <button
          type="button"
          onClick={handleLogout}
          className="mt-5 inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-4 py-2 text-xs font-bold text-gray-700 hover:bg-gray-50"
        >
          Log out
        </button>
      </div>
    </div>
  )
}
